

<p class="fs-20 fw-sbold text-center cl-primary mb-4">
  Tu mercado secundario <br> de {{ part.devName }}</p>

<div class="table-container d-flex flex-column justify-content-between">
  <div track="all" class="table-max-h mb-5">
    <table class="table info-container mnf-table">

      <thead>
        <tr>
          <th class="" scope="col">
            Desde</th>
          <th class="text-center" scope="col">
            Total en venta</th>
          <th class="text-center" scope="col">
            Vendidas</th>
          <th class="text-center" scope="col">
            Precio por c/u</th>
          <th class="text-center" scope="col"></th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let p of participations">
          <th class="text-left" scope="row">
            {{ p.createAt | date: "dd/MM/yy" }}</th>
          <th class="text-center">
            {{ p.amount }}</th>
          <td class="text-center">
            {{ p.amount }}
          </td>
          <td class="text-center">
            {{ p.createAt | currency: '$' }}</td>
          <td class="text-center">
            <fa-icon class="fs-15 cl-gray cr-pointer" [icon]="trashIcon" (click)="openModalCancelPartsOnSale(p)"></fa-icon>
          </td>
        </tr>
      </tbody>

    </table>

  </div>

  <div class="w-100 text-center">
    <button mat-button class="w-50" (click)="closeModal()">Cerrar</button>
  </div>
</div>
